var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    {
      staticClass: "pa-2",
      attrs: { cols: "6", sm: "4", md: "3", lg: "2", xl: "2" },
    },
    [
      _c(
        "v-card",
        {
          style: {
            border: _vm.order.collected
              ? "3px solid #03a9f4 !important"
              : "unset",
          },
          attrs: {
            dark: _vm.order.state !== "W",
            color: _vm.state_color,
            elevation: "3",
          },
        },
        [
          _c(
            "v-container",
            { staticClass: "py-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c("v-col", { staticClass: "pa-0", attrs: { cols: "9" } }, [
                    _c("span", { staticClass: "font-weight-medium pl-2" }, [
                      _vm._v(" " + _vm._s(_vm.order.state_display) + " "),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-img", {
            staticClass: "card-img-top",
            staticStyle: { cursor: "pointer" },
            attrs: { src: _vm.order.image_url },
            on: { click: _vm.onShowImage },
          }),
          _vm.replacements && _vm.replacements.length !== 1
            ? _c(
                "v-tabs",
                {
                  staticClass: "pt-1 disable-arrow",
                  attrs: { "fixed-tabs": "", "center-active": "" },
                  model: {
                    value: _vm.active_tab,
                    callback: function ($$v) {
                      _vm.active_tab = $$v
                    },
                    expression: "active_tab",
                  },
                },
                _vm._l(_vm.replacements, function (replacement) {
                  return _c(
                    "v-tab",
                    {
                      key: replacement.id,
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.changeOrder(replacement)
                        },
                      },
                    },
                    [
                      _c("v-img", {
                        attrs: {
                          contain: "",
                          src: replacement.image_url,
                          width: "50",
                          height: "50",
                        },
                      }),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _c("v-card-title", { staticClass: "px-2 pt-0 pb-0" }, [
            _c("div", { staticStyle: { overflow: "hidden" } }, [
              _vm.order.purchase
                ? _c("span", [
                    _vm._v(
                      "№" +
                        _vm._s(_vm.client_info.number) +
                        "/" +
                        _vm._s(_vm.order.number)
                    ),
                  ])
                : _c("span", [_vm._v("Не в закупке")]),
            ]),
          ]),
          _c(
            "v-container",
            { staticClass: "py-0 px-2 mt-n1", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { align: "start", justify: "center" } },
                [
                  _vm.order.collected
                    ? _c(
                        "v-col",
                        { staticClass: "py-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass: "light-blue text-center",
                              attrs: { elevation: "3", dark: "" },
                            },
                            [_vm._v(" Собран ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.order.paid
                    ? _c(
                        "v-col",
                        { staticClass: "py-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass: "primary text-center pa-1",
                              staticStyle: {
                                "line-height": "17px",
                                cursor: "pointer",
                              },
                              attrs: { elevation: "3", dark: "" },
                              on: { click: _vm.onShowCheck },
                            },
                            [
                              _vm._v(" Оплачен поставщику "),
                              _c("div", { staticClass: "caption mt-n1" }, [
                                _vm._v("(Показать чек)"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.order.state_comment
                    ? _c(
                        "v-col",
                        { staticClass: "py-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass: "secondary text-center",
                              attrs: { elevation: "3", dark: "" },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.order.state_comment) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-subtitle",
            {
              staticClass: "px-2 py-0 subtitle-1",
              staticStyle: { "line-height": "1.2" },
            },
            [_vm._v(" " + _vm._s(_vm.order.comment) + " "), _c("v-divider")],
            1
          ),
          !_vm.opened_link.additional.hide_price
            ? _c(
                "div",
                [
                  _vm.show_oldprice
                    ? _c(
                        "v-card-text",
                        {
                          staticClass: "pt-0 py-0 mb-n1 mt-1 pl-2 pr-0 warning",
                          staticStyle: { "text-decoration": "line-through" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.order.old_count) +
                              "шт. по " +
                              _vm._s(_vm.order.old_trade_price) +
                              " "
                          ),
                          _c(
                            "v-icon",
                            {
                              staticStyle: {
                                position: "relative",
                                bottom: "1px",
                                right: "2px",
                              },
                              attrs: { size: "15" },
                            },
                            [_vm._v(_vm._s(_vm.icon_rub))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.order.paid
                    ? _c("v-card-text", { staticClass: "pa-0 pt-1 pl-2" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "span",
                              { class: { count: _vm.order.count > 1 } },
                              [_vm._v(_vm._s(_vm.order.count) + "шт.")]
                            ),
                            _vm._v(
                              " по " + _vm._s(_vm.order.trade_price) + " "
                            ),
                            _c(
                              "v-icon",
                              {
                                staticStyle: {
                                  position: "relative",
                                  bottom: "1px",
                                  right: "6px",
                                },
                                attrs: { small: "" },
                              },
                              [_vm._v(_vm._s(_vm.icon_rub))]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _c(
                        "v-card-text",
                        { staticClass: "pa-0 pt-1 pl-2" },
                        [
                          _vm._v(" " + _vm._s(_vm.order.trade_price) + " "),
                          _c(
                            "v-icon",
                            {
                              staticStyle: {
                                position: "relative",
                                bottom: "1px",
                                right: "6px",
                              },
                              attrs: { small: "" },
                            },
                            [_vm._v(_vm._s(_vm.icon_rub))]
                          ),
                          _c(
                            "v-icon",
                            {
                              staticStyle: {
                                position: "relative",
                                bottom: "2px",
                                right: "5px",
                              },
                              attrs: { size: "13" },
                            },
                            [_vm._v(_vm._s(_vm.icon_mul))]
                          ),
                          _c(
                            "span",
                            { class: { count: _vm.order.count > 1 } },
                            [_vm._v(_vm._s(_vm.order.count) + "шт.")]
                          ),
                        ],
                        1
                      ),
                  _c(
                    "v-card-title",
                    { staticClass: "px-2 py-0 mt-n1" },
                    [
                      _vm._v(" = " + _vm._s(_vm.total_price) + " "),
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            position: "relative",
                            right: "4px",
                            bottom: "0.5px",
                          },
                          attrs: { size: "19.5" },
                        },
                        [_vm._v(_vm._s(_vm.icon_rub))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("v-card-title", { staticClass: "px-2" }, [
                    _c("span", { class: { count: _vm.order.count > 1 } }, [
                      _vm._v(_vm._s(_vm.order.count) + "шт."),
                    ]),
                  ]),
                ],
                1
              ),
          _c("v-divider", { staticClass: "mx-2" }),
          _c(
            "v-container",
            { staticClass: "px-4 pb-2 pt-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { align: "center", justify: "center" } },
                [
                  _vm.order.collected
                    ? _c(
                        "v-col",
                        {
                          staticClass: "pa-0 px-1 pt-2 text-center",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "secondary caption text-none",
                              attrs: {
                                width: "100%",
                                loading: _vm.toggle_collected_loading,
                                rounded: "",
                              },
                              on: { click: _vm.onToggleCollected },
                            },
                            [_vm._v(" НЕ СОБРАН ")]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "v-col",
                        {
                          staticClass: "pa-0 px-1 pt-2 text-center",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary caption text-none",
                              attrs: {
                                width: "100%",
                                loading: _vm.toggle_collected_loading,
                                rounded: "",
                              },
                              on: { click: _vm.onToggleCollected },
                            },
                            [_vm._v(" СОБРАН ")]
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }